import { PrintStockDto } from "./printStock.dto";
import { StockCategoryDto } from "./stockCategory.dto";
import { StockLocationDto } from "./stockLocation.dto";


export class StockTakePrintCountSheetsDto {
  stockLocation: StockLocationDto;
  stockCategory: StockCategoryDto;
  stockItems: PrintStockDto[]
}
